// extracted by mini-css-extract-plugin
export var container = "WidgetCard-module--container--5832d";
export var selected = "WidgetCard-module--selected--7c722";